module.exports = __webpack_public_path__ + "static/media/stairs-white2.5ac8f8b1.png";